import { InfoOutlined, WarningAmberOutlined } from "@mui/icons-material";
import SettingsIcon from "@mui/icons-material/Settings";
import { Menu, Tooltip } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { ThemeProvider, styled } from "@mui/material/styles";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ScrollRestoration,
  Link as domLink,
  useLocation,
} from "react-router-dom";
import LogoImage from "../HLBMEISEI-logo.png";
import { toolBarMessageActions } from "../store/store";
import theme from "../style/theme";
import Constants from "../utils/Constants";
import Loading from "./Loading";
import { default as SettingMenuList } from "./SettingMenuList";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      position="absolute"
      bottom="0"
      width="100%"
      {...props}
    >
      {"Copyright 2024 "}
      <Link color="inherit" href="https://www.hlbmeisei.jp/">
        HLB Meisei LLC.
      </Link>
    </Typography>
  );
}

const drawerWidth = 240;

//TODO:drawerの開閉処理削除
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

function SettingMenu({ settingLinkList }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div marginleft="1%">
      <Tooltip title="設定">
        <>
          <IconButton
            color="inherit"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <SettingsIcon />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <SettingMenuList settingLinkList={settingLinkList} />
          </Menu>
        </>
      </Tooltip>
    </div>
  );
}

function HeaderLinkButtons({ headerLinkList }) {
  const LinkList = headerLinkList.map((item) => {
    return (
      <Link
        color="inherit"
        noWrap
        to={item.href}
        marginLeft="1%"
        underline="none"
        key={item.href}
        component={domLink}
      >
        {item.text}
      </Link>
    );
  });

  return <>{LinkList}</>;
}

const Layout = ({ headerLinkList, settingLinkList, children }) => {
  const [open] = React.useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const toolBarMessages = useSelector((state) => state.toolBarMessage);

  React.useEffect(() => {
    // ページ切り替え時にヘッダーメッセージをリセットする
    dispatch(toolBarMessageActions.remove());
  }, [location.pathname, dispatch]);
  // TODO:コメントアウトしたcss不要？
  return (
    <ThemeProvider theme={theme}>
      <Loading />
      <AppBar
        // position="sticky"
        open={open}
        // style={{ padding: "0" }}
      >
        <Toolbar>
          <img
            src={LogoImage}
            alt=""
            style={{ height: "100%", width: "auto", marginRight: "1%" }}
          ></img>
          <Link
            variant="h6"
            color="inherit"
            noWrap
            to="./"
            sx={{ flexGrow: 1 }}
            underline="none"
            component={domLink}
          >
            HLB Meisei有限責任監査法人
          </Link>
          {headerLinkList && (
            <HeaderLinkButtons headerLinkList={headerLinkList} />
          )}
          {settingLinkList && <SettingMenu settingLinkList={settingLinkList} />}
        </Toolbar>
        {toolBarMessages?.message && (
          <Toolbar
            sx={{
              minHeight: "1.2rem",
              height: "1.2rem",
              backgroundColor:
                toolBarMessages.type === Constants.TOOL_BAR_MESSAGE_TYPE.INFO
                  ? "#64B5F6"
                  : toolBarMessages.type ===
                    Constants.TOOL_BAR_MESSAGE_TYPE.SUCCESS
                  ? "#81C784"
                  : toolBarMessages.type ===
                    Constants.TOOL_BAR_MESSAGE_TYPE.WARNING
                  ? "#FFEE58"
                  : "",
              fontWeight: "none",
              color: "#263238",
            }}
          >
            {(toolBarMessages.type === Constants.TOOL_BAR_MESSAGE_TYPE.INFO ||
              toolBarMessages.type ===
                Constants.TOOL_BAR_MESSAGE_TYPE.SUCCESS) && (
              <InfoOutlined sx={{ marginRight: "0.5rem" }} />
            )}
            {toolBarMessages.type ===
              Constants.TOOL_BAR_MESSAGE_TYPE.WARNING && (
              <WarningAmberOutlined sx={{ marginRight: "0.5rem" }} />
            )}
            <Typography variant="subtitle1">
              {toolBarMessages.message}
            </Typography>
          </Toolbar>
        )}
      </AppBar>
      <Box
      // sx={{ display: "flex" }}
      >
        <CssBaseline />
        <ScrollRestoration />
        <Box component="main">
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            {children}
          </Container>
        </Box>
      </Box>
      <Copyright sx={{ pt: 4, position: "sticky", top: "100vh" }} />
    </ThemeProvider>
  );
};

export default Layout;
